module.exports = __webpack_public_path__ + "img/room-carousel-2.cf386499.jpg";